import { ReactNode } from 'react'

export const juItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>第1条（共同利用する項目）</h3>
        <p>
        各種お問合せ時、手続き時又は各種証明資料・公的資料をご提出いただいた際にいただいたお名前、ご住所、電話番号、FAX番号、Eメールアドレス等の個人情報及び商品購入履歴。
        </p>
        <h3>第2条（共同利用する者の範囲）</h3>
        <p>
        トライアルグループ各社および株式会社SU-PAYです。
        <br />
        なお、海外のグループ各社に個人情報の提供を行う場合は、法令の定めに従い、同意の取得等必要な措置を講じます。
        </p>
        <h3>第3条（共同利用する個人情報の管理責任者）</h3>
        <p>
        福岡市東区多の津1-12-2 株式会社トライアルホールディングス
        <br />
        執行役員 小林 大悟
        </p>
      </>
    ),
    id: 'privacy1',
  }
]